import React from 'react';
import UkDocumentUpload from './UkDocumentUpload';

const UkDocumentUploadWidget = ({ id, schema, value, onChange, options }) => {
  const required = Boolean(options?.required || options?.requiredForEveryPerson);

  return (
    <UkDocumentUpload
      id={id}
      title={schema.title}
      description={schema.description}
      required={required}
      value={value}
      onChange={onChange}
    />
  );
};

export default UkDocumentUploadWidget;
